module.exports = __webpack_public_path__ + "static/media/IMG_20200417_185720.cd6d3ac8.jpg";